{
    "FormEngineMarkdownElement": {
        "title": "Richtext"
    },
    "mask": {
        "FormEngineMarkdownElement": {
            "markdownBody": "Markdown"
        }
    }
}